// Module
var code = "<div class=\"sub-buttons\"\n  ng-mouseenter=\"$ctrl.showSubMenu(true);\"\n  ng-mouseleave=\"$ctrl.showSubMenu(false);\"\n  ng-show=\"$ctrl.show && ($ctrl.itemsCount > 1)\">\n  <ng-transclude></ng-transclude>\n</div>\n";
// Exports
module.exports = code;